export default __webpack_public_path__ + "static/media/GoldLand.dc49c166.png";